var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame32(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1_3014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 4.70001H3.75V13.1H0V4.70001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.5 3.29999H2.25V14.5H1.5V3.29999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.25 1.89999H9V10.3H5.25V1.89999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.75 0.5H7.5V11.7H6.75V0.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 14,
    fill: "currentColor",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame32);
export default __webpack_public_path__ + "static/media/Frame (32).373f6c3055592285bebd66ca79b83d6d.svg";
export { ForwardRef as ReactComponent };